<template>
  <div ref="eaChartsRef02" style="height: 300px" />
</template>

<script>
import * as echarts from 'echarts';
import { debounce } from 'lodash-es';

/**
 * 每小时效率柱状图（浅色模式 + 同刻度双柱并列）
 */
export default {
  name: 'EaCharts02',
  props: {
    paramsData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      eaChartsRef02: null,
      resizeHandler: null,
      sendOnTimeRateArr: [],
      productEfficiencyArr: []
    };
  },
  computed: {
    options() {
      return {
        title: {
          text: '每小时效率 Eficiência por hora',
          left: 'left',
          textStyle: { color: '#333', fontSize: 14 }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          backgroundColor: 'rgba(255,255,255,0.9)',
          borderColor: '#ddd',
          borderWidth: 1,
          textStyle: { color: '#333', fontSize: 12 },
          formatter: (params) => {
            const hourName = params[0]?.name || '未知时段';
            let html = `<div style="padding: 4px; font-weight: 600; font-size: 12px;">${hourName}</div>`;
            params.forEach((item) => {
              const val = item.value === '-' ? '0.00%' : `${item.value}%`;
              html += `
                <p style="margin: 2px 0; display: flex; align-items: center; font-size: 12px;">
                  <span style="width: 8px; height: 8px; border-radius: 2px; background: ${item.color}; margin-right: 4px;"></span>
                  ${item.seriesName} <span style="margin-left: 8px; font-weight: 600;">${val}</span>
                </p>
              `;
            });
            return html;
          }
        },
        legend: {
          top: 25,
          left: 'center',
          data: [
            { name: '发货及时率 QTD. de fake delivery', icon: 'rect' },
            { name: '生产效率 QTD. de fake delivery', icon: 'rect' }
          ],
          textStyle: { color: '#333', fontSize: 10 },
          itemGap: 8,
          itemWidth: 8,
          itemHeight: 8
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['1小时', '2小时', '3小时', '4小时', '5小时', '6小时', '7小时', '8小时'],
          axisLine: { lineStyle: { color: '#666', width: 1 }},
          axisLabel: { color: '#333', fontSize: 10 },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
          axisLabel: { color: '#333', fontSize: 10, formatter: '{value}%' },
          splitLine: { lineStyle: { color: '#eee', type: 'dashed', width: 1 }},
          axisLine: { lineStyle: { color: '#666', width: 1 }}
        },
        series: [
          {
            name: '发货及时率 QTD. de fake delivery',
            type: 'bar',
            barWidth: '40%',
            itemStyle: { color: '#007bff' },
            label: { show: true, position: 'top', fontSize: 10, color: '#333', formatter: '{c}%' },
            data: this.sendOnTimeRateArr
          },
          {
            name: '生产效率 QTD. de fake delivery',
            type: 'bar',
            barWidth: '40%',
            itemStyle: { color: '#20c997' },
            label: { show: true, position: 'top', fontSize: 10, color: '#333', formatter: '{c}%' },
            data: this.productEfficiencyArr
          }
        ]
      };
    }
  },
  // 核心：监听props变化，数据更新自动重新渲染
  watch: {
    paramsData: {
      deep: true, // 监听对象深层变化
      handler() {
        this.renderChart(); // 数据变化触发重新渲染
      }
    }
  },
  mounted() {
    // 初始化resize监听
    this.resizeHandler = debounce(() => this.eaChartsRef02?.resize(), 100);
    window.addEventListener('resize', this.resizeHandler);
    // 首次渲染图表
    this.renderChart();
  },
  beforeDestroy() {
    // 清理监听和图表实例
    window.removeEventListener('resize', this.resizeHandler);
    this.eaChartsRef02?.dispose();
    this.eaChartsRef02 = null;
  },
  methods: {
    // 统一渲染逻辑（抽离复用，解决异步数据问题）
    renderChart() {
      // 1. 空值兜底：防止chartData不存在时报错
      const chartData = this.paramsData.chartData || [];

      // 2. 处理数据（判空+转百分比+保留3位小数）
      this.sendOnTimeRateArr = chartData.map((item) => {
        const val = item?.sendOnTimeRate;
        return !val || isNaN(parseFloat(val)) ? '0' : (parseFloat(val) * 100).toFixed(2);
      });

      this.productEfficiencyArr = chartData.map((item) => {
        const val = item?.productEfficiency;
        return !val || isNaN(parseFloat(val)) ? '0' : (parseFloat(val) * 100).toFixed(2);
      });

      // 3. 初始化/更新图表
      if (!this.eaChartsRef02 && this.$refs.eaChartsRef02) {
        this.eaChartsRef02 = echarts.init(this.$refs.eaChartsRef02);
      }
      if (this.eaChartsRef02) {
        this.eaChartsRef02.setOption(this.options);
      }
    }
  }
};
</script>
